import { Link, useNavigate } from "react-router-dom"
import { WIDGET_NAME } from "../../../../utils/constants/homeConstants"
import styles from "./liveservicewidgets.module.css"
import { connect } from "react-redux"
import { useEffect } from "react"
import { isWidgetPresent } from "../../../../utils/arrayUtils"
import Shimmer from "../../../../components/shimmer/Shimmer"
import { getLiveServiceCount, getOnboardedCustomerCount, getUserActivityCount } from "../../../../redux/actions/home/home.action"
import { FUNCTIONAL_ROLES_CONSTANTS } from "../../../../utils/constants/userConstants"
import EmptyDataView from "../../../../components/emptydataview/EmptyDataView"
import { setActivePrimaryTab } from "../../../../redux/actions/userManagement/userManagementTab.action"
import SecondaryTooltip from "../../../../components/secondaryToolTip/secondaryToolTip"

const LiveServicewidgets = ({action,liveServiceCount,userActivityCount,onBoardedCustomerCount,isHovered,...props}) => {
    const navigate = useNavigate()
    const gotoDetail = () => {
        if(!shouldShowRetry){
            switch (action) {
                case WIDGET_NAME.LIVE_SERVICES_COUNT_WIDGET:
                    return "/connectivity/liveServices";
                case WIDGET_NAME.USERS_INACTIVITY_COUNT_WIDGET:
                    return `/user-management/customerdetail/${props?.myRights?.customerUserMetaInfo?.uniqueCustomerRefId}`;
                case WIDGET_NAME.ONBOARDED_CUSTOMERS_COUNT_WIDGET:
                    return "/user-management/customers";
                default:
                    return "#";
            }
        }
    }
    useEffect(()=>{
        if(action===WIDGET_NAME.LIVE_SERVICES_COUNT_WIDGET){
            props?.getLiveServiceCount(WIDGET_NAME.LIVE_SERVICES_COUNT_WIDGET)
        }
        if(action===WIDGET_NAME.USERS_INACTIVITY_COUNT_WIDGET){
            props?.getUserActivityCount(WIDGET_NAME.USERS_INACTIVITY_COUNT_WIDGET)
        }
        if(action===WIDGET_NAME.ONBOARDED_CUSTOMERS_COUNT_WIDGET){
            props?.getOnboardedCustomerCount(WIDGET_NAME.ONBOARDED_CUSTOMERS_COUNT_WIDGET)
        }
    },[])
      
    const totalLiveServices = liveServiceCount?.liveCount + liveServiceCount?.shutdownCount;
    const totalUserActivity = userActivityCount?.activeInactiveCount?.active + userActivityCount?.activeInactiveCount?.inactive;
    const totalCustomerCount = onBoardedCustomerCount?.totalCustomerCount;

    const shouldShowRetry = (
        (action === WIDGET_NAME.LIVE_SERVICES_COUNT_WIDGET && !props?.isLoading && liveServiceCount && Object.keys(liveServiceCount).length === 0) ||
        (action === WIDGET_NAME.USERS_INACTIVITY_COUNT_WIDGET && !props?.userActivityLoading && userActivityCount && Object.keys(userActivityCount).length === 0) ||
        (action === WIDGET_NAME.ONBOARDED_CUSTOMERS_COUNT_WIDGET && !props?.onBoardedLoading && totalCustomerCount && Object.keys(totalCustomerCount).length === 0)
    );      

    const handleRetry = (type) => {
        const retryActions = {
        [WIDGET_NAME.LIVE_SERVICES_COUNT_WIDGET]: props.getLiveServiceCount,
        [WIDGET_NAME.USERS_INACTIVITY_COUNT_WIDGET]: props.getUserActivityCount,
        [WIDGET_NAME.ONBOARDED_CUSTOMERS_COUNT_WIDGET]: props.getOnboardedCustomerCount,
        };
    
        const retryFn = retryActions[type];
        if (retryFn) {
        retryFn(type);
        }
    };

    return (
        action===WIDGET_NAME.LIVE_SERVICES_COUNT_WIDGET&&props?.isLoading?<Shimmer/>:action===WIDGET_NAME.USERS_INACTIVITY_COUNT_WIDGET&&props?.userActivityLoading?<Shimmer/>:action===WIDGET_NAME.ONBOARDED_CUSTOMERS_COUNT_WIDGET&&props?.onBoardedLoading?<Shimmer/>:
        <Link className={styles.removelink} to={gotoDetail(action)} target="_blank" rel="noopener noreferrer">
        <div className={styles.liveservicewidget}>
            <div className={styles.liveservice}>
                <div className={`${styles.liveservicetext} ${isHovered ? styles.liveservicetextHover : ""}`}>
                    {`${action===WIDGET_NAME.LIVE_SERVICES_COUNT_WIDGET?"Live Services":
                    action===WIDGET_NAME.USERS_INACTIVITY_COUNT_WIDGET?"User’s Login Metrics":
                    action===WIDGET_NAME.ONBOARDED_CUSTOMERS_COUNT_WIDGET&&"Total Customers"}`}</div>
                    <div className={styles.parentlink}>
                    {shouldShowRetry ? (
                        <div className={styles.retryparent} onClick={()=>handleRetry(action)}><div className={styles.retryicon}></div><div className={styles.liveservicelink}>Refresh</div></div>):
                    <div className={styles.parent}><div className={styles.rightarrow}></div></div>}
                    </div>
            </div>
            {shouldShowRetry?<div className={styles.emptydiv}><EmptyDataView/></div>:
            <>
            <div className={styles.liveservicecard}>
                <div className={`${styles.ball} ${isHovered ? styles.ballHover : ""}`}>{action===WIDGET_NAME.LIVE_SERVICES_COUNT_WIDGET?totalLiveServices:action===WIDGET_NAME.USERS_INACTIVITY_COUNT_WIDGET?totalUserActivity:action===WIDGET_NAME.ONBOARDED_CUSTOMERS_COUNT_WIDGET?totalCustomerCount?.totalCustomers:""}</div>
                <div className={`${styles.ball} ${isHovered ? styles.ballHover : ""}`}>{action===WIDGET_NAME.LIVE_SERVICES_COUNT_WIDGET?liveServiceCount?.liveCount:action===WIDGET_NAME.USERS_INACTIVITY_COUNT_WIDGET?userActivityCount?.activeInactiveCount?.active:action===WIDGET_NAME.ONBOARDED_CUSTOMERS_COUNT_WIDGET?totalCustomerCount?.onboardedCustomers:""}</div>
                <div className={`${styles.ball} ${isHovered ? styles.ballHover : ""}`}>{action===WIDGET_NAME.LIVE_SERVICES_COUNT_WIDGET?liveServiceCount?.shutdownCount:action===WIDGET_NAME.USERS_INACTIVITY_COUNT_WIDGET?userActivityCount?.activeInactiveCount?.inactive:action===WIDGET_NAME.ONBOARDED_CUSTOMERS_COUNT_WIDGET?totalCustomerCount?.pendingCustomers:""}</div>
            </div>
            <div className={styles.livescard}>
                <div className={`${styles.text} ${styles.flexstrt}`}>Total</div>
                <div className={`${styles.text} ${styles.flexcenter}`}>{`${action===WIDGET_NAME.LIVE_SERVICES_COUNT_WIDGET?"Live":action===WIDGET_NAME.USERS_INACTIVITY_COUNT_WIDGET?"Active Users":action===WIDGET_NAME.ONBOARDED_CUSTOMERS_COUNT_WIDGET?"Onboarded":""}`}</div>
                <div className={`${styles.text} ${styles.flexend}`}>{`${action===WIDGET_NAME.LIVE_SERVICES_COUNT_WIDGET?"Shutdown":action===WIDGET_NAME.USERS_INACTIVITY_COUNT_WIDGET?"Inactive Users":action===WIDGET_NAME.ONBOARDED_CUSTOMERS_COUNT_WIDGET?"Pending":""}`}</div>
            </div>
            </>}
        </div>
        </Link>
    )
}
const mapStateToProps = (state) => {
    return {
      liveServiceCount:state?.dashBoardCounts?.liveServiceCount?.data,
      isLoading:state?.dashBoardCounts?.liveServiceCount?.isLoading,
      userActivityCount:state?.dashBoardCounts?.userActivityCount?.data,
      userActivityLoading:state?.dashBoardCounts?.userActivityCount?.isLoading,
      onBoardedCustomerCount:state?.dashBoardCounts?.onBoardedCustomerCount?.data,
      onBoardedLoading:state?.dashBoardCounts?.onBoardedCustomerCount?.isLoading,
      myRights : state.myRights.myRights,
    }
  }
  const mapDispatchToProps = (dispatch)=>{
    return {
        getLiveServiceCount: (action) => {
          return dispatch(getLiveServiceCount(action))
        },
        getUserActivityCount: (action) => {
          return dispatch(getUserActivityCount(action))
        },
        getOnboardedCustomerCount: (action) => {
            return dispatch(getOnboardedCustomerCount(action))
        },
        setActivePrimaryTab: (tab) => {
            return dispatch(setActivePrimaryTab(tab))
        },
    }
  }
export default connect(mapStateToProps,mapDispatchToProps)(LiveServicewidgets)